import { render } from "./P055.vue?vue&type=template&id=03d0afb7&scoped=true"
import script from "./P055.vue?vue&type=script&lang=js"
export * from "./P055.vue?vue&type=script&lang=js"

import "./P055.vue?vue&type=style&index=0&id=03d0afb7&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d0afb7"]])

export default __exports__